const layoutConfigFor = (layout, domainSettings) => {
  const defaultLayoutConfig = domainSettings.layouts.find(({is_default}) => is_default)

  const layoutConfig = domainSettings.layouts.find(({name}) => {
    return layout === name
  }) || defaultLayoutConfig

  return layoutConfig
}

export {
  layoutConfigFor,
}
